import Vue from 'vue/dist/vue.esm'
import RobofinderAppComponent from '../components/robofinder_app.vue'

export default () => {
  document.addEventListener("turbolinks:load", () => {
    const appElement = document.getElementById('robofinder-app');
    if (appElement) {
      const elem = new Vue({
        el: '#robofinder-app',
        components: { RobofinderAppComponent },
        data() {
          return {
            initialParamsJson: appElement.dataset.initialParams,
            apiMetaUrl: appElement.dataset.apiMetaUrl,
            apiResultsUrl: appElement.dataset.apiResultsUrl,
            isSignedIn: appElement.dataset.isSignedIn,
            isMobile: appElement.dataset.isMobile,
            translations: appElement.dataset.translations,
            referrerUrl: appElement.dataset.referrerUrl,
            locale: appElement.dataset.locale
          }
        },
        template: `
          <robofinder-app-component
            :initial-params-json="initialParamsJson"
            :api-meta-url="apiMetaUrl"
            :api-results-url="apiResultsUrl"
            :is-signed-in="isSignedIn"
            :is-mobile="isMobile"
            :translations="translations"
            :referrer-url="referrerUrl"
            :locale="locale"
          />
        `
      });
    }
  });
};
